import { PaymentMethodsContainer } from '@/modules/PaymentMethods';

export const PaymentMethods = (): JSX.Element => <PaymentMethodsContainer />;

export default PaymentMethods;
